import { useState } from "react";
import NotificationInfo from "./components/NotificationInfo";
import Targeting from "./components/Targeting";
import DeliverySchedule from "./components/DeliverySchedule";

const AddNotification = ({ formData, setFormData, form, handlePublish }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isExit, setIsExit] = useState(false);

  if (currentStep === 1) {
    return (
      <NotificationInfo
        formData={formData}
        setFormData={setFormData}
        setCurrentStep={setCurrentStep}
        form={form}
      />
    );
  }

  if (currentStep === 2) {
    return (
      <Targeting
        formData={formData}
        setFormData={setFormData}
        setCurrentStep={setCurrentStep}
        form={form}
      />
    );
  }

  if (currentStep === 3) {
    return (
      <DeliverySchedule
        formData={formData}
        setFormData={setFormData}
        setCurrentStep={setCurrentStep}
        form={form}
        handlePublish={handlePublish}
      />
    );
  }

  return <div>AddNotification</div>;
};

export default AddNotification;
